/**
 * Opciones por defecto para los quizzes del Supertest (escenario 8).
 * En la web se muestran como a), b), c)...; aquí guardamos id numérico, text (HTML) y correct.
 */

export const DEFAULT_SUPERTEST_1_OPTIONS = [
	{ id: 1, text: "La NL constituye la afectación orgánica grave más frecuente del LES, dado que hasta el 60 % de los pacientes con LES pueden llegar a tener NL durante el curso de su vida.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 2, text: "La NL se caracteriza por la aparición de proteinuria en grado variable, alteraciones en el sedimento urinario, deterioro de la función renal y en algunos casos, desarrollo de hipertensión arterial.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 3, text: "La presencia de NL se asocia con un mayor riesgo de complicaciones cardiovasculares, daño orgánico irreversible y mortalidad prematura.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 4, text: "Son incorrectas las afirmaciones B y C.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 5, text: "No hay afirmaciones incorrectas.", correct: true, explanation: "", confirmExplanation: "" },
];

export const DEFAULT_SUPERTEST_2_OPTIONS = [
	{ id: 1, text: "Ha demostrado ser eficaz en nefritis lúpica de nuevo diagnóstico.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 2, text: "Ha demostrado ser eficaz en recaídas.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 3, text: "Se puede utilizar en pacientes con nefritis lúpica de clase IV y V, pero no III.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 4, text: "A y B son correctas.", correct: true, explanation: "", confirmExplanation: "" },
	{ id: 5, text: "A, B y C son correctas.", correct: false, explanation: "", confirmExplanation: "" },
];

export const DEFAULT_SUPERTEST_3_OPTIONS = [
	{ id: 1, text: "La preservación de la función renal a largo plazo, junto con los resultados de seguridad favorables del estudio Aurora 2, dan a entender que esta afirmación es verdadera.", correct: true, explanation: "", confirmExplanation: "" },
	{ id: 2, text: "Aunque la voclosporina puede ofrecer beneficios terapéuticos en el tratamiento de la NL, su uso como parte del tratamiento estándar durante 3 años aún plantea interrogantes sobre su tolerabilidad, por lo que esta afirmación, tal y como está formulada, es falsa.", correct: false, explanation: "", confirmExplanation: "" },
	{ id: 3, text: "Si bien los resultados de seguridad en el estudio Aurora 1 fueron positivos, los del estudio Aurora 2 desaconsejan el uso de voclosporina durante un período mayor de un año, por lo que la afirmación es falsa.", correct: false, explanation: "", confirmExplanation: "" },
];

function isSupertest1Name(quizData) {
	const name = (quizData?.fullName || "").toLowerCase();
	return name.includes("supertest 1") || name.includes("supertest1");
}

function isSupertest2Name(quizData) {
	const name = (quizData?.fullName || "").toLowerCase();
	return name.includes("supertest 2") || name.includes("supertest2");
}

function isSupertest3Name(quizData) {
	const name = (quizData?.fullName || "").toLowerCase();
	return name.includes("supertest 3") || name.includes("supertest3");
}

/**
 * Devuelve las opciones por defecto para el quiz de Supertest según su fullName.
 */
export function getDefaultSupertestOptions(quizData) {
	if (!quizData) return DEFAULT_SUPERTEST_1_OPTIONS;
	if (isSupertest3Name(quizData)) return DEFAULT_SUPERTEST_3_OPTIONS;
	if (isSupertest2Name(quizData)) return DEFAULT_SUPERTEST_2_OPTIONS;
	return DEFAULT_SUPERTEST_1_OPTIONS;
}
